module.exports = __webpack_public_path__ + "static/media/71sRKFnH1VL._AC_SL1500_.50a0622c.jpg";